module.exports = __webpack_public_path__ + "../static/media/TitilliumWeb-Black.4206d227.ttf";